import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleError(error: any): void {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    if (chunkFailedMessage.test(error?.message)) {
      window.location.reload();
      return;
    }

    if (error instanceof Error) {
      console.error('Error occurred:', error.message);
      if (error.stack) {
        console.error('Stack trace:', error.stack);
      }
    } else if (error && typeof error === 'object') {
      console.error('Error occurred:', JSON.stringify(error, null, 2));
    } else {
      console.error('Unexpected error:', error);
    }
  }
}
